import {RelationNotificationDay} from "@/constants/relation-notification-days";
import {Language} from "@/constants/language";

export interface OrganizationLoadUnloadNotificationSettings {
  useNotificationsForInbound: boolean;
  emailNotificationForInbound: boolean;
  timeOfInboundNotification: string | null;
  inboundNotificationDay: RelationNotificationDay | null;

  useNotificationsForOutbound: boolean;
  emailNotificationForOutbound: boolean;
  timeOfOutboundNotification: string | null;
  outboundNotificationDay: RelationNotificationDay | null;

  defaultLanguage: Language;
}

export const DefaultOrganizationLoadUnloadNotificationSettings = (): OrganizationLoadUnloadNotificationSettings => {
  return {
    useNotificationsForInbound: false,
    emailNotificationForInbound: true,
    timeOfInboundNotification: "18:00:00",
    inboundNotificationDay: RelationNotificationDay.DayBefore,

    useNotificationsForOutbound: false,
    emailNotificationForOutbound: true,
    timeOfOutboundNotification: "18:00:00",
    outboundNotificationDay: RelationNotificationDay.DayBefore,

    defaultLanguage: Language.nlNL,
  };
};
